import {AgencyRepositoryType} from "../../../repositories/interfaces/AgencyRepositoryType.ts";
import {AgencyObservation} from "../../entities/Agency.ts";

export class AddAgencyObservationUseCase {
    constructor(private readonly agencyRepository: AgencyRepositoryType) {}

    execute(agencyId: string, text: string): Promise<AgencyObservation> {
        return this.agencyRepository.addAgencyObservation(agencyId, text.trim())
    }
}
